import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { AppHistory } from "@faire/help-center-utils/AppHistory";
import { initializeHotjar } from "@faire/help-center/initialize/hotjar";
import { setupHotLoading } from "@faire/web/common/hotReloading";
import { HistoryTiming } from "@faire/web/common/performance/HistoryTiming";
import { ResourceTimingCollector } from "@faire/web/common/performance/ResourceTimingCollector";
import { initializePolyfill } from "@faire/web/common/polyfill";
import { reloadExpiredSessions } from "@faire/web/common/releaseReloader";
import once from "lodash/once";
export default once( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return initializePolyfill();
      case 2:
        reloadExpiredSessions();
        setupHotLoading("8767");
        initializeHotjar();
        ResourceTimingCollector.get().initialize();
        HistoryTiming.get().initialize(AppHistory.get().history);
      case 7:
      case "end":
        return _context.stop();
    }
  }, _callee);
})));